export const convertToBoolean = (s: string): boolean => {
	try {
		return JSON.parse(s);
	} catch (e) {
		return false;
	}
};
